const modelSurveyForm = {
  醫療護理照護: [
    {
      question: '1. 醫師的醫療處置能協助您的恢復狀況?',
      type: 'grade',
      skipped: false,
      skipReason: null,
      response: null,
    },
    {
      question: '2. 醫師能細心聆聽您說話?',
      type: 'grade',
      skipped: false,
      skipReason: null,
      response: null,
    },
    {
      question: '3. 護理人員能以尊重的態度對待您?',
      type: 'grade',
      skipped: false,
      skipReason: null,
      response: null,
    },
    {
      question: '4. 護理人員能用您聽得懂得方式說正在進行的治療或照護?',
      type: 'grade',
      skipped: false,
      skipReason: null,
      response: null,
    },
    {
      question: '5. 婦產科病房',
      type: 'questionGroup',
      skipped: false,
      skipReason: '尚未接受出院衛教(勾選此可略過婦產科病房調查問項)',
      response: null,
      contents: [
        {
          question: '(1) 病房護理人員有向您說明協助的諮詢管道，是否符合您需求?',
          type: 'grade',
          skipped: false,
          skipReason: null,
          response: null,
        },
        {
          question: '(2) 病房護理人員有提供口頭及書面資料，教導離院後應如何自我照護?',
          type: 'grade',
          skipped: false,
          skipReason: null,
          response: null,
        },
      ],
    },
    {
      question: '6. 嬰兒室',
      type: 'questionGroup',
      skipped: false,
      skipReason: '我不是產科媽媽(勾選此可略過嬰兒室調查問項)',
      response: null,
      contents: [
        {
          question: '(1) 嬰兒室護理人員是否有向您自我介紹?',
          type: 'grade',
          skipped: false,
          skipReason: null,
          response: null,
        },
        {
          question: '(2) 嬰兒室護理人員在您住院期間，提供母乳方面相關的衛教及資訊是否符合您需求?',
          type: 'grade',
          skipped: false,
          skipReason: null,
          response: null,
        },
        {
          question: '(3) 嬰兒室護理人員在您住院期間，提供照顧嬰兒方面相關的衛教及資訊是否符合您需求?',
          type: 'grade',
          skipped: false,
          skipReason: null,
          response: null,
        },
        {
          question: '(4) 對於您育兒的提問，嬰兒室護理人員回答是否讓您滿意?',
          type: 'grade',
          skipped: false,
          skipReason: '未使用',
          response: null,
        },
      ],
    },
    {
      question: '7. 您按過緊急鈴之後，能得到及時性的協助?',
      type: 'grade',
      skipped: false,
      skipReason: '未使用',
      response: null,
    },
  ],
  醫療行政服務: [
    {
      question: '8. 餐飲部:',
      type: 'questionGroup',
      skipped: false,
      skipReason: '未訂餐(勾選此項可略過餐飲部調查)',
      response: null,
      contents: [
        {
          question: '(1). 對於菜色是否感到滿意?',
          type: 'grade',
          skipped: false,
          skipReason: null,
          response: null,
        },
        {
          question: '(2). 對於餐點的量是否感到滿意?',
          type: 'grade',
          skipped: false,
          skipReason: null,
          response: null,
        },
        {
          question: '(3). 對於送餐人員態度?',
          type: 'grade',
          skipped: false,
          skipReason: null,
          response: null,
        },
      ],
    },
    {
      question: '9. 清潔部:',
      type: 'questionGroup',
      skipped: false,
      skipReason: null,
      response: null,
      contents: [
        {
          question: '(1) 對於病房內整體環境的清潔?',
          type: 'grade',
          skipped: false,
          skipReason: null,
          response: null,
        },
        {
          question: '(2) 對於目前提供的清潔時間、次數是否感到滿意?',
          type: 'grade',
          skipped: false,
          skipReason: null,
          response: null,
        },
        {
          question: '(3) 對於清潔人員態度?',
          type: 'grade',
          skipped: false,
          skipReason: null,
          response: null,
        },
      ],
    },
  ],
  環境設施: [
    {
      question: '10. 對於病房區的硬體設備(如:陪病床、茶水間等)?',
      type: 'grade',
      skipped: false,
      skipReason: null,
      response: null,
    },
    {
      question: '11. 對於病房溫度的舒適度?',
      type: 'grade',
      skipped: false,
      skipReason: null,
      response: null,
    },
    {
      question: '12. 對於病房夜間的安寧?',
      type: 'grade',
      skipped: false,
      skipReason: null,
      response: null,
    },
  ],
  其他: [
    {
      question: '13. 對於本院的住院流程是否感到滿意?',
      type: 'grade',
      skipped: false,
      skipReason: null,
      response: null,
    },
    {
      question: '14. 對於本院的出院流程是否感到滿意?',
      type: 'grade',
      skipped: false,
      skipReason: '尚未辦理出院',
      response: null,
    },
    {
      question: '15. 在本院就診及住院期間，對於維護您的個人隱私權是否讓您滿意?',
      type: 'grade',
      skipped: false,
      skipReason: null,
      response: null,
    }, {
      question: '16. 對於本院整體的住院滿意度為?',
      type: 'grade',
      skipped: false,
      skipReason: null,
      response: null,
    },
    {
      question: '17. 在這段期間，您是否有特別想表揚的工作人員?',
      type: 'textarea',
      skipped: false,
      skipReason: null,
      response: '',
    },
    {
      question: '18. 請跟我們分享您的喜悅心得或寶貴建議:',
      type: 'textarea',
      skipped: false,
      skipReason: null,
      response: '',
    },
    {
      question: '19. 是否希望得到回覆:',
      type: 'trueFalse',
      skipped: false,
      skipReason: null,
      response: '',
    },
    {
      question: '20. E-Mail(非必填):',
      type: 'textarea',
      skipped: false,
      skipReason: null,
      response: '',
    },
    {
      question: '21. 親愛的媽媽您是否同意 將您的「返家照片」放在本院官網一起分享您的喜悅:',
      type: 'agree',
      skipped: false,
      skipReason: null,
      response: false,
    },
    {
      question: '22. 親愛的媽媽您是否同意 將您的「喜悅心得」放在本院官網一起分享您的喜悅:',
      type: 'agree',
      skipped: false,
      skipReason: null,
      response: false,
    },
    {
      question: '23. 親愛的媽媽您是否會向朋友推薦 本院。\n若是推薦，結束問卷後將會跳轉至Google評論。',
      type: 'recommend',
      skipped: false,
      skipReason: null,
      response: null,
      contents: [
        {
          question: '承23. 不推薦的理由:',
          type: 'textarea',
          skipped: false,
          skipReason: null,
          response: '',
        },
      ],
    },
  ],
};

export default modelSurveyForm;
//! use npm vue-excel-xlsx 匯出
